// src/pages/Process.jsx
import React from "react";
import libraryHero from "../assets/library-hero.png"; // copy image into src/assets

function GlassCard({ step, title, children }) {
  return (
    <div className="glass card-glow hover-lift p-6 rounded-xl transition-all duration-300">
      <div className="flex items-center gap-3 mb-3">
        <div className="w-10 h-10 rounded-full bg-green-600 text-white flex items-center justify-center font-bold">
          {step}
        </div>
        <h3 className="font-semibold text-lg">{title}</h3>
      </div>
      <p className="text-slate-700 text-sm">{children}</p>
    </div>
  );
}

export default function Process() {
  return (
    <div className="max-w-7xl mx-auto py-16 px-6">
      <header className="text-center mb-12">
        <h1 className="text-3xl md:text-4xl font-semibold h-font text-green-700">
          Our Investment Process
        </h1>
        <p className="mt-4 text-slate-600 max-w-3xl mx-auto">
          At Apar Growth Partners, we believe successful investing comes from
          discipline, research, and patience. Our process is designed to uncover
          attractive investment opportunities and thereby build lasting wealth
          for our clients.
        </p>
      </header>

      <div className="mb-8">
        <img
          src={libraryHero}
          alt="library"
          className="w-full rounded-xl object-cover h-56 md:h-72"
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <GlassCard step="1" title="Focus on Quality">
          We invest in companies with a proven track record and long-standing
          presence in the market. Our focus is on quality businesses—those
          gaining market share vis-à-vis the industry; having above average
          return ratios; and run by sensible management team.
        </GlassCard>

        <GlassCard step="2" title="Finding Opportunities">
          We try to identify investment opportunities through our proprietary
          screens, industry network, and extensive research across publications.
          We follow a bottom-up approach, focusing on individual companies
          rather than entire sectors.
        </GlassCard>

        <GlassCard step="3" title="In-depth Research">
          We study a company’s long-term performance, their quarterly updates,
          industry dynamics, competitor landscape, and global peers operating in
          the same sector. As part of our channel checks, we try to engage with
          ecosystem partners —such as vendors, customers, employees (past and
          present), industry experts, etc. — to get further insights. This
          rigorous process ensures we invest only after developing a thorough
          understanding of the business.
        </GlassCard>

        <GlassCard step="4" title="Valuing Businesses">
              Our goal is to invest in quality companies at a meaningful
              discount to their intrinsic value, providing both downside
              protection and long-term growth potential.
            </GlassCard>

        {/* Point 5 moved into middle as per instruction: Risk Management sits in middle */}

        {/* Centered final card: spans both columns on md and is horizontally centered */}
        <div className="md:col-span-2 flex justify-center">
          <div className="w-full md:w-10/12 lg:w-3/4">
            <GlassCard step="5" title="Risk Management">
          Risk management is central to our philosophy. To protect against a
          permanent loss of capital or any sort of large drop in our invested
          capital, we:
          <ul className="list-disc pl-5 mt-2 text-slate-700 text-sm">
            <li>
              buy stocks at price levels which offer adequate margin of safety.
            </li>
            <li>buy quality companies run by good managements</li>
            <li>keep a portfolio of 20-25 companies at all times.</li>
            <li>
              adjust position sizes based on business quality and the
              price-value gap.
            </li>
            <li>
              Lastly hold cash when markets don’t offer attractive opportunities.
            </li>
          </ul>
          
        </GlassCard>
          </div>
        </div>
      </div>
    </div>
  );
}
